module.exports = __webpack_public_path__ + "static/media/news-7.d8c01a90.webp";